@if (order.Balance < 0) {
  <span class="chipbox chipbox-warning" data-testid="order-paid-status-overpaid">{{ 'CUSTOMER.ORDERS.LISTVIEW.CHIPBOX.OVERPAID' | translate}}</span>
}
@if (order.Balance == 0) {
  <span class="chipbox chipbox-closed" data-testid="order-paid-status-paid">{{ 'CUSTOMER.ORDERS.LISTVIEW.CHIPBOX.PAYED' | translate}}</span>
}
@if (order.Balance > 0) {
  @if (order.Balance < order.TotalInclVat) {
    <span class="chipbox chipbox-warning" data-testid="order-paid-status-partially-paid">{{ 'CUSTOMER.ORDERS.LISTVIEW.CHIPBOX.PARTIALLY' | translate}}</span>
  }
  @if (order.Balance >= order.TotalInclVat) {
    <span class="chipbox chipbox-open" data-testid="order-paid-status-open">{{ 'CUSTOMER.ORDERS.LISTVIEW.CHIPBOX.OPEN' | translate}}</span>
  }
}
